/**
 * Validate that a file is UTF-8 encoded by attempting to decode it.
 */
export const validateUtf8Encoding = (file: File): Promise<{ isValid: boolean; error?: string }> => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = event => {
      try {
        const decoder = new TextDecoder("utf-8", { fatal: true });
        decoder.decode(event.target?.result as ArrayBuffer);
        resolve({ isValid: true });
      } catch {
        resolve({
          isValid: false,
          error:
            "The CSV file must be UTF-8 encoded. Please save your file with UTF-8 encoding and try again.",
        });
      }
    };
    reader.onerror = () => {
      resolve({ isValid: false, error: "Failed to read the file. Please try again." });
    };
    reader.readAsArrayBuffer(file);
  });
};
